<template>
    <div v-for="(customInput, key) in customInputs"
         :key="key"
         class="form-group">
        <label :for="'prompt-value-' + key"
               class="block text-center">
            {{ l(customInput.label) }}
        </label>
        <input :id="'prompt-value-' + key"
               v-model="form[key]"
               type="text"
               class="form-control input-lg text-center"
               @keydown.enter="$emit('enter')" />
    </div>
</template>

<script>
export default {
    props: {
        /**
         * Some additional input fields to be rendered in the modal.
         * The value should be an object where they key is the key for the input and
         * the value is and object with: {
         *     label: A language key to render for the input label.
         *     placeholder: A language key to render for the input placeholder.
         * }
         */
        customInputs: {
            type: Object,
            default: () => ({}),
        },

        /**
         * Cheeky two-way binding for the form data, but that is the simplest way to achieve this.
         */
        form: {
            type: Object,
            required: true,
        },
    },

    emits: ['enter'],

    created() {
        Object.keys(this.customInputs).forEach((key) => {
            this.form[key] = this.customInputs[key].value;
        });
    },
};
</script>
